<script setup lang="ts">
import {PiniaColadaDevtools} from '@pinia/colada-devtools'

import {useEnvConfig} from "./composables/useEnvConfig"
import {type ApiErrorResponse, isApiErrorResponse} from './types/api-error'

const { addApiError } = useApiErrorNotifications()
const { clear } = useUserSession()
client.setConfig({
    baseUrl: "/api"
})
client.interceptors.response.use(async (response) => {
    if (!response.ok) {
        if (response.status === 401) {
            await clear()
            await navigateTo("/api/auth/keycloak", { external: true })
        } else {
            const error = await response.clone().json()
            if (isApiErrorResponse(error.data) && !error.data.statusCode.toString().startsWith("4")) {
                const apiError: ApiErrorResponse = {
                    errorCode: error.data.errorCode || 'Unknown Error',
                    message: error.data.message || 'An unknown error occurred',
                    traceId: error.data.traceId || 'n/a',
                    statusCode: error.data.statusCode,
                    timestamp: error.data.timestamp || Date.now()
                }
                addApiError(apiError)
            } else {
                console.error(`API Error: ${response.status} ${response.statusText} for ${response.url}`)
            }
        }
    }
    return response
})

const { loadEnvConfig } = useEnvConfig()

await loadEnvConfig()

</script>

<template>
    <VitePwaManifest />
    <NuxtLayout>
        <UApp>
            <NuxtPage />
        </UApp>
    </NuxtLayout>

</template>
